import React from "react";
import Carousel from 'react-bootstrap/Carousel';
import "../CSS/TestimonialCarrousel.css"; 

const testimonials = [
  {
    name: "Mr Deepak Sharma",
    title: "",
    image: require("../Images/Testimonial/DeepakSharma.png"),
    stars: 5,
    content: `The best part of investing with ValueFundz or Dilip Ji Morani, you are always connected. His response time is best and he makes sure that investment is performing well. I strongly recommend him for all financial services`,
  },
  {
    name: "Mrs Anjali Patolia",
    title: "",
    image: require("../Images/Testimonial/AnjaliPatolia.png"),
    stars: 5,
    content: `ValueFundz is a great financial distributor entity, their service is beyond expectations. They believe in high customer oriented deliverables .From inception to end they assist you for your investments/insurances etc.My remarks are out of own very recent experience with them.Thanks Valuefundz for your support throughout my case. Looking forward towards a long financial relationship.`,
  },
  {
    name: "Mr. Ankit Dugar",
    title: "",
    image: require("../Images/Testimonial/AnkitDugar.jpeg"),
    stars: 5,
    content: `I, Ankit Dugar from DR INFRA SOLUTIONS INDIA, Jaipur, would like to introduce ourselves as Waterproofing solutions & Construction Chemical company. We work pan India.
Mr. Dilip Morani is into Mutual Funds and Investments, based out in C-Scheme, JAIPUR.
His company VALUEFUNDZ and his team are dedicated to help for mutual funds based
investments. They suggest, execute and follow-up diligently so that nothing is missed.
I would appreciate Mr. Dilip Morani to keep the quality standards so high and dedicated to
maintain them.
I recommend his services to everyone & wish him luck for his future endeavours.`,
  },
  {
    name: "CA Dinesh Vijay",
    title: "",
    image: require("../Images/Testimonial/DineshAgarwal.jpeg"),
    stars: 5,
    content: `I express my thankfulness
and gratitude for the excellent professional services
rendered to us in connection with the captioned matter.
In today's money centered scenario, it is extremely difficult to find the service oriented professionally managed team like VALUEFUNDZ.
I am touched by the prompt and satisfying service by your entire team. I wish VALUEFUNDZ reaches the heights of success in its professional journey.`,
  },
  // Add more testimonials as needed
];

const TestimonialCarousel = () => {
    return (
      <div className="testimonial-section">
        <h2 className="section-title">What our clients say is extremely important to us</h2>
        <div className="quote-icon">❞</div>
  
        <Carousel indicators={true} interval={4000} pause="hover">
          {testimonials.map((testimonial, index) => (
            <Carousel.Item key={index}>
              <div className="testimonial-card">
                <img src={testimonial.image} alt={testimonial.name} className="profile-pic" />
                <h4 className="name">{testimonial.name}</h4>
                <p className="designation">{testimonial.title}</p>
                <div className="stars">
                  {"★".repeat(testimonial.stars)}
                </div>
                <p className="content">{testimonial.content}</p>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    );
  };
  
  export default TestimonialCarousel;